import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "footnotefirstbaseline"
    }}>{`FootnoteFirstBaseline`}</h1>
    <p>{`Options for specifying the amount of vertical space between the top of the footnote container and the first line of footnote text.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ASCENT_OFFSET`}</strong>{` = 1296135023`}</p>
      <p parentName="blockquote">{`The tallest character in the font falls below the top of the footnote container.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CAP_HEIGHT`}</strong>{` = 1296255087`}</p>
      <p parentName="blockquote">{`The tops of upper case letters touch the top of the footnote container.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_OFFSET`}</strong>{` = 1296852079`}</p>
      <p parentName="blockquote">{`The leading value of the text defines the distance between the baseline of the text and the top of the footnote container.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EMBOX_HEIGHT`}</strong>{` = 1296386159`}</p>
      <p parentName="blockquote">{`The em box height of the text defines the distance between the baseline of the text and the top of the footnote container.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`X_HEIGHT`}</strong>{` = 1299728495`}</p>
      <p parentName="blockquote">{`The tops of lower case letters without ascents, such as x, touch the top of the footnote container.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIXED_HEIGHT`}</strong>{` = 1313228911`}</p>
      <p parentName="blockquote">{`The footnote minimum first baseline offset value defines the distance between the baseline of the text and the top of the footnote container.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      